<template>
  <ComboboxItem>
    <Component
      :is="isTruncated ? Tooltip : Primitive"
      :asChild="!isTruncated"
      :delay="300"
      :side="'right'"
      :title="label"
    >
      <div class="px-2.5 flex gap-2 items-center truncate">
        <div
          @click="$emit('update:modelValue', item)"
          class="transition h-4 w-4 border border-primary rounded-full after:block after:w-0 after:h-0 after:content-[''] after:bg-white after:rounded-full hover:ring-brand focus-within:ring-brand flex justify-center items-center"
          :class="{ 'bg-brand-solid after:w-[5px] after:h-[5px]': checked }"
        />
        <span class="truncate grow text-left" ref="labelElement">
          {{ item?.label || label }}
        </span>
      </div>
    </Component>
  </ComboboxItem>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { ComboboxItem, Primitive } from "radix-vue";
import { Tooltip } from "@/SharedComponents/Tooltips";
import { isTruncating } from "@/Utils/truncate";

const labelElement = ref(null);

defineProps({
  checked: { type: Boolean, default: false },
  label: { type: String, required: false },
  item: { type: Object, required: false },
});

const isTruncated = ref(false);

onMounted(() => {
  setTimeout(() => {
    isTruncated.value = isTruncating(labelElement.value);
  }, 500);
});
</script>
